import Translation from './translation'

export default class Video extends Translation
{
    get active_ar() {
        return this.locales.includes('ar');
    }

    get active_en() {
        return this.locales.includes('en');
    }
    
    get active_fa() {
        return this.locales.includes('fa');
    }

    constructor(video){
        super()
        this.id             = 0
        
        this.locales        = []
        
        this.title_ar       = ''
        this.title_en       = ''
        this.title_fa       = ''
        
        this.description_ar = ''
        this.description_en = ''
        this.description_fa = ''

        this.published      = false
        this.video_url      = null
        this.video_uuid     = null
        this.video_image    = ''
        this.tags           = []

        this.map(video)
        this.init()
    }

    map(video){
        if(video == undefined) return
        this.id             = video.id
        this.video_url      = video.video_url
        this.video_uuid     = video.video_uuid
        this.video_image    = 'https://img.youtube.com/vi/'+ video.video_uuid +'/default.jpg'
        this.published      = video.published_at != null
        this.tags           = video.tags??[]
        this.created_at     = video.created_at  
        this.updated_at     = video.updated_at  
        this.published_at   = video.published_at  

        for (let locale in video.translations) {
            this['title_' + locale] = video.translations[locale].title
            this['description_' + locale] = video.translations[locale].description??null
            this.locales.push(locale);
        }
        this.setLocale(this.locales)
    }

    toFormData(){
        let fData = new FormData()
        
        for(let locale of this.locales){

            fData.append('translation['+ locale +'][title]', this['title_'+ locale]);
            fData.append('translation['+ locale +'][description]', this['description_'+ locale]);
        }
        

        fData.append('published', Number(this.published));
        fData.append('video_url', this.video_url);

        return fData
    }
}

